import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

export const InstructionsModal = ({ isOpen, toggle, notes }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-lg">
      <ModalHeader toggle={toggle}>
        <h5 className="modal-title">Item Instructions</h5>
      </ModalHeader>
      <ModalBody className="p-0">
        <Table responsive bordered className="mb-0">
          <thead>
            <tr>
              <th scope="col" className="text-center" style={{ width: "40%" }}>
                Item Details
              </th>
              <th scope="col" className="text-center" style={{ width: "60%" }}>
                Special Instructions
              </th>
            </tr>
          </thead>
          <tbody>
            {notes?.map(
              ({ name, quantity, price, currency, notes: noteText }, i) => (
                <tr key={i}>
                  <td className="align-middle text-center">
                    <div className="d-flex flex-column">
                      <span className="font-weight-bold">{name}</span>
                      <span className="text-muted small">
                        Qty: {quantity} • {currency || "USD"}{" "}
                        {price?.toFixed?.(2) || "0.00"}
                      </span>
                    </div>
                  </td>
                  <td className="align-middle">
                    <div
                      className="p-2 text-wrap"
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {noteText || (
                        <span className="text-muted font-italic">
                          No instructions provided
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
